import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import { INVOICE_STATUSES } from '@src/shared/types/invoice';
import { createSimpleFilterConfig } from '../factories/create-simple-filter-config';

export const invoiceStatusFilterConfig = createSimpleFilterConfig({
  facetName: 'status',
  options: Object.values(INVOICE_STATUSES).map((status) => ({
    label: formatTextForDisplay(status),
    value: status,
  })),
});
